// extracted by mini-css-extract-plugin
module.exports = {"content":"bodyXLManifesto_content__AOiAw","bodies":"bodyXLManifesto_bodies__r2e8_ typography_bodyExtraLarge__sUWvZ","buttonGroup":"bodyXLManifesto_buttonGroup__hwpa7"};